const routes = {
  V3_LOGIN: {
    path: "/v3/game/login",
    method: "post"
  },
  V3_NEW_CHALLENGES: {
    path: "/v3/game/challenges/newv3",
    method: "get"
  },
  V3_INPLAY_CHALLENGES: {
    path: "/v3/game/challenges/inPlayv2",
    method: "get"
  },
  V3_COMPLETED_CHALLENGES: {
    path: "/v3/game/challenges/completedv2",
    method: "get"
  },
  V3_GET_CONTESTS: {
    path: "/v4/utils/getContestData",
    method: "get"
  },

  V3_GET_REWARDS: {
    path: "/v3/game/challenges/rewards_ua",
    method: "get"
  },
  V3_GET_RULES: {
    path: "/v3/game/contest/rules_ua",
    method: "get"
  },
  V3_GET_MATCHINFO: {
    path: "/v3/game/challenges/matchinfo",
    method: "get"
  },
  V3_GET_LEADERBOARD: {
    path: "/loyalty/v1/leaderboard/active",
    method: "get"
  },
  V3_GET_HISTORYREWARDS: {
    path: "/v3/game/challenges/historyrewards",
    method: "get"
  },
  V1_GET_HISTORY:{
    path: "/loyalty/v1/leaderboard/history",
    method: "get"
  },
  V1_GET_WEEKS_PRIZES:{
    path: "/loyalty/v1/leaderboard/lbprizes",
    method: "get"
  },
  V3_GET_OLD_LEADERBOARD:{
    path: "/loyalty/v1/leaderboard/old",
    method: "get"
  },
  V1_GET_EARNPOINTS:{
    path: "/loyalty/v1/leaderboard/howtogetxp",
    method: "get"
  },
  V1_GET_HELP:{
    path: "/loyalty/v1/leaderboard/help",
    method: "get"
  },
  V1_OPEN_REWARDS:{
    path: "/loyalty/v1/leaderboard/openRewards",
    method: "get"
  },
  V1_GET_MARKETING_PRIZES:{
    path: "/loyalty/v1/leaderboard/marketing/lbprizes",
    method: "get"
  },
  V1_GET_MARKETING_EARNPOINTS:{
    path: "/loyalty/v1/leaderboard/marketing/howtogetxp",
    method: "get"
  },
  
  V1_GET_MARKETING:{
    path: "/loyalty/v1/leaderboard/marketing",
    method: "get"
  },
  // V3_GET_RULES: {
  //   path: "/v3/game/contest/rules",
  //   method: "get"
  // },
  V3_GET_CONTEST_ROOMS: {
    path: "/v3/game/challenges/contestRooms",
    method: "get"
  },
  V3_GET_CHALLENGE_MATCHES: {
    path: "/v3/game/challenges/getUserMatchesv2",
    method: "get"
  },
  V3_GET_ROOM_LEADERBOARDS: {
    path: "/v3/game/rooms/leaderboards",
    method: "get"
  },
  V3_JOIN_CONTEST_QUEUE: {
    path: "/v3/game/challenges/joinContestQueue",
    method: "post"
  },
  V3_VERIFY_JOIN_CONTEST: {
    path: "/v3/game/challenges/verifyJoinContest",
    method: "post"
  },
  V3_GET_PLAY_QUESTION: {
    path: "/v3/game/users/question",
    method: "get"
  },
  V3_POWERUP_TRANSFER_STATS: {
    path: "/v3/game/users/powerupTransferStats",
    method: "post"
  },
  V3_POWERUP_TRANSFER_FROM_BANK: {
    path: "/v3/game/users/transferFromBank",
    method: "post"
  },
  V4_POST_ANSWER: {
    path: "/v4/utils/users/answer",
    method: "post"
  },
  V3_POST_EDITED_ANSWER: {
    path: "/v3/game/users/editAddAnswer",
    method: "post"
  },
  V3_USER_POLL: {
    path: "/v3/game/users/poll",
    method: "post"
  },
  V1_UPDATE_PROFILE: {
    path: "/v1/game/users/updateProfile",
    method: "post"
  },
  V2_VERIFY_REFERRAL_CODE: {
    path: "/v2/game/verifyReferralCode",
    method: "get"
  },
  V2_GET_OTP: {
    path: "/v2/game/resendOTP",
    method: "get"
  },
  V1_ONBOARD_PROFILE_REFERRAL: {
    path: "/v1/game/users",
    method: "put"
  },
  V1_GET_USER: {
    path: "/v1/game/users",
    method: "get"
  },
  V2_VERIFY_OTP: {
    path: "/v2/game/verifyOTP",
    method: "get"
  },
  V1_GET_USER_WALLET: {
    path: "/v1/wallet/getUserWallet",
    method: "post"
  },
  V1_PUT_USER_PAYMENTINFO: {
    path: "/v2/game/users/paymentInfo",
    method: "put"
  },
  V1_ADD_MONEY_CASHFREE: {
    path: "/v1/wallet/addMoneyToWallet",
    method: "post"
  },
  V1_GET_TRANX_HISTORY: {
    path: "/v1/wallet/getUserTransactionsV2",
    method: "get"
  },
  V3_GAME_USER_RESULTS: {
    path: "/v3/game/users/results",
    method: "get"
  },
  V1_VERIFY_ORDER_STATUS: {
    path: "/v1/wallet/getOrderStatus",
    method: "get"
  },
  V1_UTILITY_ADDFILETOS3: {
    path: "/v1/utility/addFileToS3",
    method: "post"
  },
  V3_GAME_CASHFREE_ADDBANK: {
    path: "/v3/game/cashfree/addBankBeneficiary",
    method: "post"
  },
  V1_WALLET_WITHDRAW: {
    path: "/v1/wallet/withdraw",
    method: "post"
  },
  V1_GET_SERVER_TIME: {
    path: "/v1/utility/getServerTime",
    method: "get"
  },
  TOP_CHALLENGES: {
    path: "/v3/game/web/topChallenges",
    method: "get"
  },
  V2_GAME_GET_REFERRAL_SCREEN: {
    path: "/v2/game/getReferralScreen",
    method: "get"
  },
  V2_GAME_GET_REFERRAL_TRANSACTIONS: {
    path: "/v2/game/getReferralTransactions",
    method: "get"
  },
  V3_GAME_ACTIVITES: {
    path: "/v3/game/users/activities",
    method: "get"
  },
  GET_POWER_UP_TRANS: {
    path: "/v2/game/store/getPowerupTransaction",
    method: "get"
  },
  GET_BANNER: {
    path: "/v3/game/users/banners2",
    method: "get"
  },
  V3_GAME_GET_PLAYER_RESULT: {
    path: "/v3/game/getPlayerMatchResult",
    method: "get"
  },
  V2_GAME_GET_PRODUCTS_BY_CATEGORY: {
    path: "/v2/game/store/getProductsByCategory",
    method: "get"
  },
  V1_WALLET_USEWALLET: {
    path: "/v1/wallet/useWallet",
    method: "post"
  },
  V3_GAME_WHATS_NEW: {
    path: "/v3/game/whatsNew",
    method: "get"
  },
  V3_GAME_COMPARE_PLAYER_RESULT: {
    path: "/v3/game/comparePlayerMatchResult",
    method: "get"
  },
  V3_GAME_GET_STATUS: {
    path: "/v3/game/getStatus",
    method: "get"
  },
  V3_GAME_GET_UPLOADED_KYC_DOC: {
    path: "/v3/game/getKycUploadedDocforUser",
    method: "get"
  },
  V3_GAME_UPLOAD: {
    path: "/v3/game/upload",
    method: "post"
  },
  V3_GET_SLIDES: {
    path: "/v3/game/slides",
    method: "get"
  },
  V3_GAME_SEGMENTS: {
    path: "/v3/game/segments/all",
    method: "get"
  },
  V4_USER_EXIST: {
    path: "/v4/utils/isUserExist",
    method: "post"
  },
  V4_SEND_OTP: {
    path: "/v4/utils/sendOTP",
    method: "post"
  },
  V4_POST_OTP: {
    path: "/v4/utils/verifyOTP",
    method: "post"
  },
  V4_SIGNUP: {
    path: "/v4/utils/login",
    method: "post"
  },
  V4_UPDATE_PROFILE: {
    path: "/v4/utils/updateProfile",
    method: "post"
  },
  V4_UTILS_RESET_PASSWORD: {
    path: "/v4/utils/resetPassword",
    method: "post"
  },
  V4_UTILS_LOGIN: {
    path: "/v4/utils/login",
    method: "post"
  },
  V4_UTILS_SEND_OTP: {
    path: "/v4/utils/sendOTP",
    method: "post"
  },
  V4_UTILS_PASSWORD_EXIST: {
    path: "/v4/utils/isPasswordExist",
    method: "post"
  },
  V4_UTILS_GET_USER_DATA: {
    path: "/v4/utils/getUserData",
    method: "get"
  },
  V4_UTILS_CHANGE_MOBILE: {
    path: "/v4/utils/changeMobile",
    method: "post"
  },
  V4_UTILS_CHANGE_PASSWORD: {
    path: "/v4/utils/changePassword",
    method: "post"
  },
  V4_UTILS_USER_BENEFITS: {
    path: "/v4/utils/userBenefits",
    method: "post"
  },
  V1_GET_SETTINGS_BODY: {
    path: "/v1/setting/getSettingsBody",
    method: "get"
  },
  V3_GET_CONTEST_OFFERS: {
    path: "/v3/game/getContestOffersForWeb",
    method: "get"
  },
  V4_WALLET_DYNAMIC_WITHDRAWAL: {
    path: "/v4/wallet/dynamicWithrawal",
    method: "get"
  },
  V3_GAME_JOIN_PSEUDO_CONTEST: {
    path: "/v3/game/challenges/joinPseudoContestv2",
    method: "post"
  },
  V3_GET_PLAY_QUESTIONS: {
    path: "/v4/utils/users/questions",
    method: "get"
  },
  V3_GAME_GET_INPLAY_MATCHES: {
    path: "/v3/game/challenges/getInplayMatchesUserv2",
    method: "get"
  },
  V3_GET_MATCH_ANSWERS: {
    path: "/v3/game/getUserPseudoAnswers",
    method: "get"
  },
  V3_GAME_GET_CONTEST_PICKS: {
    path: "/v3/game/getUserChallengeContestPlaysv2",
    method: "get"
  },
  V3_GAME_COPY_ANSWERS: {
    path: "/v3/game/users/copyMatchAnswersv2",
    method: "post"
  },
  V1_GAME_GET_PLAYER_PROFILE: {
    path: "/v1/game/users/getPlayerProfile",
    method: "get"
  },
  V3_GAME_USERS_MATCHES_TIMELINE: {
    path: "/v3/game/users/matches/timeline",
    method: "get"
  },
  V1_WALLET_USEWALLET: {
    path: "/v1/wallet/useWallet",
    method: "post"
  },
  V4_UTILS_SWITCH_INITIATE_TRANSACTION: {
    path: "/v4/utils/phonepe/getSwitchLink",
    method: "post"
  },
  V4_UTILS_SWITCH_GET_STATUS: {
    path: "/v4/utils/phonepe/getSwitchTransactionStatus",
    method: "post"
  },
  SET_LANG: {
    path: "/v4/utils/setLanguage",
    method: "post"
  },
  BULK_ANSWER: {
    path: "/v4/utils/users/answerInBulk",
    method: "post"
  },
  RESET_ANSWERS: {
    path: "/v4/utils/users/resetAllAnswers",
    method: "post"
  },
  V4_GAME_QUIZPYPL_GETLIVEQUIZ_HISTORY: {
    path: "/v4/game/quizpypl/getLiveQuizHistory",
    method: "get"
  },
  V4_GAME_QUIZPYPL_GET_WALLET: {
    path: "/v4/game/quizpypl/getUserWallet",
    method: "get"
  },
  V4_GAME_QUIZPYPL_GET_USER: {
    path: "/v4/game/quizpypl/users",
    method: "get"
  }
};

export default routes;



// WEBPACK FOOTER //
// ./src/utils/routes.js